module.exports = __webpack_public_path__ + "img/2.005d5fba.svg";